import apiClient from "./client";

export const serviceAgreement = {
  getByToken: () => apiClient.get("/policies/hizmet-sozlesmesi"),
};
